import React, { ChangeEvent, FC, useState } from 'react';
import Textbox from '~/src/components/form-components/textbox/textbox';
import { FIO_REGEX, MAX_LENGTH } from '~/src/components/common-components/fio-field/fio-field.constants';
import type { TextBoxFieldProps } from '~/src/models/types/fields.types';

export const FioField: FC<TextBoxFieldProps> = ({ onClear, ...props }) => {
    const [fioValue, setFioValue] = useState('');

    const onFioValidHandler = (event: ChangeEvent<HTMLInputElement>) => {
        const _value = event.target.value || '';
        setFioValue((_value.match(FIO_REGEX) || []).join(''));
    };

    const handleClear = () => {
        onClear && onClear();
        setFioValue('');
    };

    return (
        <Textbox
            value={fioValue}
            onValueChange={onFioValidHandler}
            onClear={handleClear}
            maxLength={MAX_LENGTH}
            {...props}
        />
    );
};